export default "__VITE_ASSET__gxpuDNQJ__"